<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>

        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="ApplyFee">
                            <!--  -->
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-9">
                                                <div class=" d-flex align-items-center pl-3">
                                                    <img alt="Logo" src="../../assets/img/purse.png"
                                                        class="mh-45px pb-2">
                                                    <div class="ml-2">
                                                        <h3 class="main-content-label mb-1"><b>
                                                                Apply Exam Fee
                                                            </b></h3>
                                                        <p class="text-muted card-sub-title mb-0">
                                                            List Of Exam Fee
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- <div class="col-sm-3">
                                                <button id="addBtn" type="button" [disabled]="PayLater"
                                                    class="btn ht btn-primary btn-icon-text hg" (click)="OpenPopUp()">
                                                    <span style="display: flex; align-items: center;">
                                                        Pay Later
                                                    </span>
                                                </button>
                                            </div> -->
                                        </div>

                                        <hr>
                                        <div class="row clearfix mt-2">
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Session</mat-label>
                                                            <mat-select #select232 placeholder="Session"
                                                                class="colorblack" formControlName="SessionId">
                                                                <mat-select-filter *ngIf="select232.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                    [array]="sessionList"
                                                                    (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of SessionFilterList"
                                                                    [value]="item.SnNo" (click)="fetchCollege()">
                                                                    <!--  -->
                                                                    {{item.SnName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label> College Name</mat-label>
                                                    <mat-select #select23 placeholder="CgCode" class="colorblack"
                                                        formControlName="college">
                                                        <mat-select-filter *ngIf="select23.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                            [array]="collegeList"
                                                            (filteredReturn)="filteredCollegeList =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredCollegeList"
                                                            (click)="fetchCourse(item.CgCode)" [value]="item.CgCode">
                                                            {{item.CgCode}} - {{item.CgName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-3">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label> Course Name</mat-label>
                                                    <mat-select #select29 placeholder="CoCode" class="colorblack"
                                                        formControlName="course">
                                                        <mat-select-filter *ngIf="select29.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                            [array]="CourseList"
                                                            (filteredReturn)="filteredCourseList =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredCourseList"
                                                            [value]="item.CoCgCoCode"
                                                            (click)="fetchSupExamRecord(item.CoCgCoCode)">
                                                            {{item.CoCgCoCode}} - {{item.CoName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Exam Available</mat-label>
                                                            <mat-select formControlName="Exam" #select3901
                                                                placeholder="Exam Available" class="colorblack">
                                                                <mat-select-filter *ngIf="select3901.focused"
                                                                    [placeholder]="'Exam Available'"
                                                                    [displayMember]="'EmName'" [array]="ExamAList"
                                                                    (filteredReturn)="filteredExamAList =$event">
                                                                </mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredExamAList"
                                                                    [value]="item.EmId"
                                                                    (click)="getExmSchedule(item.EmId,item.EmSrNo)">
                                                                    {{item.EmCode}} - {{item.EmName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="Table" class="table-responsive table-container tab mt-1">
                                                <table id="datatable"
                                                    class="table table-bordered text-nowrap text-left">
                                                    <thead>

                                                        <tr class="text-left">
                                                            <th class="f600">
                                                                Student Name
                                                            </th>
                                                            <th class="f600">
                                                                Template Name
                                                            </th>
                                                            <!-- <th class="f600">
                                                                Student Status
                                                            </th>
                                                            <th class="f600">
                                                                Admission Mode
                                                            </th> -->
                                                            <th class="f600 text-center">Action</th>
                                                            <th class="f600 text-center">Receipt</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="feeApplyArray">

                                                        <tr *ngFor="let fee of getfeeApplyArrayControls(); let i = index; let last = last; let item of FeeTable "
                                                            [formGroupName]="i">

                                                            <td>
                                                                <input class="form-controls input-sm"
                                                                    formControlName="StudentName" readonly>
                                                            </td>
                                                            <td>
                                                                <input class="form-controls input-sm"
                                                                    formControlName="TemplateName" readonly>
                                                            </td>
                                                            <!-- <td>
                                                                <input class="form-controls input-sm"
                                                                    formControlName="StuStatus" readonly>
                                                            </td>
                                                            <td>
                                                                <input class="form-controls input-sm"
                                                                    formControlName="StuAdm" readonly>
                                                            </td> -->
                                                            <td class="text-center">
                                                                <ng-container *ngIf="PayStatus[i]">
                                                                    <h3 class="main-content-label mb-1"
                                                                        (click)="checkLock2(item,'Paid')">
                                                                        <b>{{FeePaid}}</b>
                                                                    </h3>
                                                                </ng-container>
                                                                <!-- <ng-container *ngIf="Paylater[i]">
                                                                    <button type="button"
                                                                        class="btn2 sz btn-primary btn-icon-text floatright mt-1 fr"
                                                                        (click)="checkLock2(item,'PayLater')">
                                                                        <span
                                                                            style="display: contents; align-items: center;">
                                                                            <img width="20vh"
                                                                                src="../../assets/img/pay-per-click.gif"
                                                                                style="margin-right: 1px; margin-left: -19px">
                                                                            Pay Later
                                                                        </span>
                                                                    </button>
                                                                </ng-container> -->
                                                                <ng-container *ngIf="!PayStatus[i] && !Paylater[i]">
                                                                    <button type="button"
                                                                        class="btn sz btn-primary btn-icon-text floatright mt-1 fr"
                                                                        (click)="checkLock2(item,'Pay')">
                                                                        <span
                                                                            style="display: contents; align-items: center;">
                                                                            <img width="20vh"
                                                                                src="../../assets/img/pay-per-click.gif"
                                                                                style="margin-right: 5px;"> Pay
                                                                        </span>
                                                                    </button>
                                                                </ng-container>
                                                            </td>
                                                            <td class="text-center" *ngIf="PayStatus[i]">
                                                                <h3 class="main-content-label mb-1">
                                                                    <b (click)="paymentReceipt(item)"> Payment
                                                                        Status</b>
                                                                </h3>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>